import cs from 'classnames';
import { Fragment, type ReactNode } from 'react';

import styles from './dot-separator.module.css';

type P = {
  className?: string;
  items: Array<{ content: ReactNode; key: string }>;
  separatorClassName?: string;
};

const DotSeparator = ({ className, items, separatorClassName }: P) => (
  <div className={cs(styles.wrapper, className)}>
    {items.map((item, index) => (
      <Fragment key={`${item.key}_dot-separator`}>
        {item.content}
        {index < items.length - 1 && <div className={cs(styles.separator, separatorClassName)} />}
      </Fragment>
    ))}
  </div>
);

export default DotSeparator;
